import moment from "moment";
import { PaymentMethod } from "../../../utils/pagarme";

// ── currency ──────────────────────────────────────────────────────────────────

export const fmtCurrency = (value = 0) =>
  `R$ ${Number(value)
    .toFixed(2)
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;

export const centsToReais = (cents = 0) => Number(cents || 0) / 100;

// ── documents ─────────────────────────────────────────────────────────────────

export const formatCPF = (doc = "") => {
  const d = doc.replace(/\D/g, "");
  if (d.length !== 11) return doc;
  return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
};

export const formatCNPJ = (doc = "") => {
  const d = doc.replace(/\D/g, "");
  if (d.length !== 14) return doc;
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
};

export const formatZipcode = (zip = "") => {
  const d = zip.replace(/\D/g, "");
  if (d.length !== 8) return zip;
  return d.replace(/^(\d{5})(\d{3})$/, "$1-$2");
};

// ── invoice identifiers ───────────────────────────────────────────────────────

const yearOf = (order) =>
  moment(order.dataTransaction).isValid()
    ? moment(order.dataTransaction).format("YYYY")
    : new Date().getFullYear();

const seqOf = (order) =>
  String(order.idTransaction || "").slice(-6).padStart(6, "0");

export const formatInvoiceNumber = (order) =>
  `FAT-${yearOf(order)}-${seqOf(order)}`;

export const formatOrderNumber = (order) =>
  `PED-${yearOf(order)}-${seqOf(order)}`;

// ── date ──────────────────────────────────────────────────────────────────────

export const formatDatePDF = (date) =>
  date ? moment(date).format("DD/MM/YYYY") : "—";

// ── payment ───────────────────────────────────────────────────────────────────

export const formatPaymentMethod = (method) => PaymentMethod(method) || method || "—";

// ── products ──────────────────────────────────────────────────────────────────

export const getUnitPrice = (product) =>
  product.ProductSale ? product.ProductSalePrice : product.ProductPrice;

export const getProductLineTotal = (product) =>
  product.ProductQuantity * getUnitPrice(product);

export const getOrderSubtotal = (order) => {
  if (!order?.products?.length) return 0;
  return order.products.reduce((sum, p) => sum + getProductLineTotal(p), 0);
};

export const getDeliveryFee = (order) =>
  centsToReais(order?.delivery?.fee || 0);

// ── customer ──────────────────────────────────────────────────────────────────

export const getCustomerCPF = (order) => {
  const doc = order?.customer?.documents?.find((d) => d.type === "cpf");
  return doc?.number ? formatCPF(doc.number) : "—";
};

export const getCustomerAddress = (order) =>
  order?.shippingAddress || order?.delivery?.address || null;

export const formatAddressLine = (addr) => {
  if (!addr) return null;
  const number = addr.street_number ? `, ${addr.street_number}` : "";
  const comp = addr.complementary ? ` – ${addr.complementary}` : "";
  return `${addr.street || ""}${number}${comp}`;
};

// ── image fetching ────────────────────────────────────────────────────────────

export const fetchImageAsBase64 = async (url) => {
  try {
    if (!url) return null;
    const res = await fetch(url);
    if (!res.ok) return null;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
};
